<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Documents">
    <div class="giga-content_container">
      <template v-if="!isSimulationStepper">
        <documents-filter
          v-on:download="download()"
          :queryConfig="queryConfig"
          @applyFilter="applyFilter($event)"
          @reloadData="applyFilter($event)"
          @applySearch="applySearch($event)"
        >
        </documents-filter>
      </template>

      <!-- <div
          v-if="loading"
          class="giga-pre_loading"
      >
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div> -->

      <page-loader v-if="loading" :pageHasActions="true"></page-loader>

      <template v-else>
        <!--    TODO: set isSimulation -->
        <import-mass-step1
          :fileUploadId="'fileImportInMass'"
          :filesToFill="files"
          :isVIEWER="isVIEWER"
          :replace="false"
          :isSimulation="isSimulation"
          :isToBeCompleted="false"
          :selectDocuments="selectedDocsIds"
          :importInMassOperations="importInMassOperations"
          @estimations-preview-updated="handleEstimationsPreviewUpdate"
        >
        </import-mass-step1>

        <div v-if="!loading" class="giga-card_list">
          <documents-actions
            :documents="getDocuments"
            :isVIEWER="isVIEWER"
            :selectDocuments="selectedDocsIds"
            :isSimulation="isSimulation"
            v-on:download="download()"
            :queryConfig="queryConfig"
            @applyFilter="applyFilter($event)"
            @reloadData="applyFilter($event)"
          >
          </documents-actions>

          <!-- DOCUMENT A COMPLETER -->
          <div v-if="!hideComplete && noDocToBeCompleted" class="giga-card">
            <div>
              <h3 class="giga-card_title">Documents à compléter</h3>
            </div>
            <div class="giga-card_content">
              <table class="giga-table docs-table none-hover">
                <thead>
                  <tr>
                    <th class="giga-checkAll_table">
                      <div
                        class="giga-cutsom_checkbox"
                        :class="classObjectToBeCompleted"
                      >
                        <input
                          type="checkbox"
                          name="checkboxName"
                          v-model="allRowsSelectedToBeCompleted"
                          @change="selectAllRowsToBeCompleted"
                          id=""
                        />
                        <label for="checkboxName"></label>
                      </div>
                    </th>
                    <th class="giga-document_name">Nom du document</th>
                    <th class="giga-document_date">Date de transmission</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="document in $v.getDocuments.$each.$iter">
                    <tr
                      v-if="!document.transmitted.$model"
                      :key="document.id.$model"
                    >
                      <td>
                        <div class="giga-cutsom_checkbox">
                          <input
                            type="checkbox"
                            name="checkboxName"
                            v-model="selectedRowToBeCompleted"
                            :value="document.id.$model"
                            @click="selectDocument(document.id.$model)"
                          />
                          <label for="checkboxName"></label>
                        </div>
                      </td>
                      <td class="giga-document_name">
                        <div class="giga-document_name_label">
                          <i class="extention-icon">
                            <img
                              v-if="
                                getFileExtention(document.name.$model) == 'xlsx'
                              "
                              src="~@/assets/images/extensions/xls.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'txt'
                              "
                              src="~@/assets/images/extensions/txt.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'pdf'
                              "
                              src="~@/assets/images/extensions/pdf.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'docx'
                              "
                              src="~@/assets/images/extensions/doc.svg"
                            />
                            <img
                              v-else-if="
                                getFileExtention(document.name.$model) == 'doc'
                              "
                              src="~@/assets/images/extensions/doc.svg"
                            />
                            <img
                              v-else
                              src="~@/assets/images/extensions/text.svg"
                            />
                          </i>
                          {{ getDocExtention(document.name.$model) }}
                        </div>
                      </td>
                      <td class="giga-document_date">
                        {{
                          moment(document.creationDate.$model, "x").format(
                            "DD/MM/YYYY"
                          )
                        }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

          <template v-if="!isSimulationStepper">
            <div class="giga-document_footer giga-flex giga-flex_end">
              <div class="giga-button">
                <button
                  class="giga-green_button no-icon"
                  v-if="!isVIEWER"
                  @click="confirmSave"
                  :disabled="isInvalid"
                >
                  <span>{{ $t("save") }}</span>
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <!-- SAVE CHANGES MODAL -->
    <b-modal
      id="modal-save_changes"
      title="BootstrapVue"
      modal-class="giga-modal giga-actions_modal"
      hide-footer
      hide-header
    >
      <h2 class="giga-modal_title">{{ $t("save_changes") }}</h2>
      <div class="giga-modal_body">
        <p>{{ $t("confirm_save") }}</p>
      </div>
      <div class="giga-modal_footer">
        <div class="giga-button">
          <button
            class="giga-blue_outlined_button no-icon"
            @click="$bvModal.hide('modal-save_changes')"
          >
            {{ $t("dont_save") }}
          </button>
        </div>
        <div class="giga-button">
          <button class="giga-green_button no-icon" @click="saveDocuments">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </b-modal>

    <!--    <b-modal
      id="modal-confirm_leave"
      title="BootstrapVue"
      modal-class="giga-modal giga-actions_modal"
      hide-footer
      hide-header
    >
      <h2 class="giga-modal_title">{{ $t("unsaved_changes") }}</h2>
      <div class="giga-modal_body">
        <p>{{ $t("changes_will_be_discarded") }}</p>
      </div>
      <div class="giga-modal_footer">
        <div class="giga-button">
          <button class="giga-red_button no-icon" @click="discardDocuments">
            {{ $t("confirm") }}
          </button>
        </div>
        <div class="giga-button">
          <button
            class="giga-green_button no-icon"
            @click="$bvModal.hide('modal-confirm_leave')"
          >
            {{ $t("stay") }}
          </button>
        </div>
      </div>
    </b-modal>-->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import DocumentsActions from "@/components/static/DocumentsActions.vue";
import DocumentsFilter from "@/components/static/DocumentsFilter.vue";
import { find, some, map } from "lodash";
import { documentService } from "../../service/document.service";
import eventBus from "@/shared/event.bus";
import { queryConstant } from "@/shared/queryConstant";
import PageLoader from "../../../components/static/pageLoader.vue";
import { required } from "vuelidate/lib/validators";
import { helpers } from "@/shared/helper";
import ImportMassStep1 from "@/views/Simulations/import-mass-estimations/ImportMassStep1.vue";

export default {
  components: {
    ImportMassStep1,
    DocumentsActions,
    DocumentsFilter,
    PageLoader
  },
  name: "ImportMassDocuments",
  props: [
    "simulation",
    "isSimulationStepper",
    "importInMassOperations",
    "files"
  ],
  data() {
    return {
      selectedRowToBeCompleted: [],
      allRowsSelectedToBeCompleted: false,
      selectedRow: [],
      allRowsSelected: false,
      toBeCompleted: true,
      hideComplete: "",
      hideTransmitted: "",
      value: document.types,
      selectedDocsIds: [],
      selectedDocs: [],
      checkTypes: "", // TODO: chekcTypes ?
      customFilter: queryConstant.setDefaultCustomFilter(),
      queryConfig: queryConstant.DOCUMENT_CONFIG,
      isSimulation: false,
      search: ""
    };
  },
  validations: {
    getDocuments: {
      $each: {
        id: {},
        name: {},
        types: {},
        transmitted: {},
        creationDate: {}
      }
    }
  },
  created() {
    /*    window.addEventListener("beforeunload", this.beforeWindowUnload);
    window.addEventListener("unload", e => this.discardDocuments());*/
  },
  /*  beforeRouteLeave(to, from, next) {
    if (this.checkDraftDocuments()) {
      this.$root.$emit("bv::show::modal", "modal-confirm_leave");
      this.$root.$on("bv::modal::hidden", () => {
        this.getLeavePage ? next() : next(false);
      });
    } else {
      next();
    }
  },*/
  mounted() {
    this.isSimulation = this.simulation !== undefined ? this.simulation : false;
    this.setLeavePage(false);
  },
  computed: {
    ...mapGetters("work", ["getWork"]),
    ...mapGetters("simulation", ["getSimulation"]),
    ...mapGetters("document", [
      "getDocuments",
      "getDocumentsTypes",
      "getSelectedDocuments",
      "getDraftDocuments",
      "getLeavePage",
      "getDocFormInvalid"
    ]),
    ...mapGetters("loader", { loading: "getLoading" }),
    noDocToBeCompleted() {
      return some(this.getDocuments, { transmitted: false });
    },
    // isToBeCompleted() {
    //   return some(this.getSelectedDocuments, { transmitted: false });
    // },

    classObject() {
      return {
        indeterminateRows:
          this.getTransmittedFiles.length > this.selectedRow.length &&
          this.selectedRow.length >= 1,
        allRows: this.getTransmittedFiles.length == this.selectedRow.length
      };
    },
    classObjectToBeCompleted() {
      return {
        indeterminateRows:
          this.getTobeCompleted.length > this.selectedRowToBeCompleted.length &&
          this.selectedRowToBeCompleted.length >= 1,
        allRows:
          this.getTobeCompleted.length == this.selectedRowToBeCompleted.length
      };
    },
    isInvalid() {
      return (
        this.$v.getDocuments.$invalid ||
        this.getDocFormInvalid ||
        ((!this.getDocuments || this.getDocuments.length === 0) &&
          (!this.getDraftDocuments || this.getDraftDocuments.length === 0))
      );
    },
    getTransmittedFiles() {
      const transmittedFiles = this.getDocuments.filter(
        file => file.transmitted === true
      );
      return transmittedFiles;
    },
    getTobeCompleted() {
      const toBeCompleted = this.getDocuments.filter(
        file => file.transmitted === false
      );
      return toBeCompleted;
    },
    isVIEWER() {
      return helpers.isVIEWER();
    }
  },
  watch: {
    getDocuments() {
      if (this.getDocuments.length) {
        this.getDocuments.forEach(doc => {
          const types = [];
          if (doc.types) {
            doc.types.forEach(type => {
              types.push(find(this.getDocumentsTypes, { code: type }));
            });
          }
          doc.types = types;
        });
      }
    },
    selectedRow(arr) {
      this.allRowsSelected = arr.length !== 0;
    },

    "$v.$invalid": function() {
      if (this.isSimulation) {
        const invalid = this.$v.getDocuments.$invalid;
        eventBus.$emit("invalid-form", invalid);
      }
    }
    /*    getDraftDocuments: function() {
      this.setSimulationChanged(
        this.getDraftDocuments && this.getDraftDocuments.length > 0
      );
    }*/
  },
  methods: {
    ...mapActions("work", ["getWorkByIdAction"]),
    ...mapActions("document", [
      "getDocumentsAction",
      "getDocumentsTypesAction",
      "saveDocumentsAction",
      "deleteDraftDocumentsAction",
      "editDocumentTypesAction"
    ]),
    ...mapMutations("document", [
      "setSelectedDocuments",
      "setDraftDocuments",
      "setDocuments",
      "setLeavePage",
      "setDocFormInvalid"
    ]),
    ...mapMutations("simulation", ["setSimulationChanged"]),
    selectAllRows() {
      if (this.allRowsSelected) {
        this.selectedRow = [];
        const selectedItem = this.getDocuments
          .filter(doc => {
            return doc.transmitted === true;
          })
          .map(doc => {
            var row = {};
            (row["id"] = doc.id), (row["transmitted"] = doc.transmitted);
            if (doc.transmitted) {
              return row["id"];
            }
          });
        this.selectedDocsIds = selectedItem;
        selectedItem.forEach(item => {
          this.selectedRow.push(item);
        });
      } else {
        this.selectedRow = [];
        this.selectedDocsIds = [];
      }
    },

    selectAllRowsToBeCompleted() {
      if (this.allRowsSelectedToBeCompleted) {
        this.selectedRowToBeCompleted = [];
        const selectedRowItem = this.getDocuments
          .filter(doc => {
            return doc.transmitted === false;
          })
          .map(doc => {
            var row = {};
            row["id"] = doc.id;
            row["transmitted"] = doc.transmitted;
            if (!doc.transmitted) {
              return row["id"];
            }
          });
        selectedRowItem.forEach(item => {
          this.selectedRowToBeCompleted.push(item);
        });
        this.selectedDocsIds = selectedRowItem;
      } else {
        this.selectedRowToBeCompleted = [];
        this.selectedDocsIds = [];
      }
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    getDocExtention(docname) {
      let split = docname.split(".");
      let filename = split[0];
      let extension = split[1];
      if (filename.length > 10) {
        docname = filename.substring(0, 18);
      }
      return docname + "..." + extension;
    },
    getAllDocuments() {
      const id = this.isSimulation
        ? this.getSimulation.id
        : parseInt(this.$route.params["id"], 10);
      if (id) {
        this.getDocumentsAction({
          id: id,
          customFilter: this.customFilter,
          search: this.search
        });
      } else {
        this.setDocuments({});
      }
    },
    selectDocument(id) {
      const index = this.selectedDocsIds.indexOf(id);
      if (index > -1) {
        this.selectedDocsIds.splice(index, 1);
      } else {
        this.selectedDocsIds.push(id);
      }
      const docs = [];
      const allDocs = JSON.parse(JSON.stringify(this.getDocuments));
      this.selectedDocsIds.forEach(docId => {
        docs.push(find(allDocs, { id: docId }));
      });
      if (docs && docs.length) {
        this.setSelectedDocuments(docs);
      }
    },
    download() {
      documentService.downloadDocuments(this.selectedDocsIds);
    },
    applyFilter(event) {
      this.selectedDocsIds = [];
      this.customFilter = event.filter.custom;
      this.getAllDocuments();
    },
    applySearch(event) {
      this.search = event.search;
      this.getAllDocuments();
    },
    saveDocuments() {},
    discardDocuments() {
      if (this.getDraftDocuments && this.getDraftDocuments.length > 0) {
        const draftDocuments = this.getDraftDocuments;
        this.setDraftDocuments(null);
        this.deleteDraftDocumentsAction({
          documentsName: map(draftDocuments, "fileName"),
          showLoader: false
        });
      }
      this.$bvModal.hide("modal-confirm_leave");
      this.setLeavePage(true);
    },
    saveDraftDocuments() {
      const drafts = this.getDraftDocuments;
      const id = this.isSimulation
        ? this.getSimulation.id
        : parseInt(this.$route.params["id"], 10);
      if (drafts && drafts.length > 0) {
        drafts.forEach(document => {
          if (Array.isArray(document.types)) {
            document.types = map(document.types, "code");
          } else {
            document.types = [document.types.code];
          }
        });
        this.setDraftDocuments(null);
        this.saveDocumentsAction({
          id: id,
          customFilter: this.customFilter,
          documentsToUpload: drafts
        });
      }
    },
    unselectDocs() {
      this.allRowsSelected = false;
      this.selectedDocsIds = [];
      this.allRowsSelectedToBeCompleted = [];
      this.selectedRowToBeCompleted = [];
      this.selectedRow = [];
      this.setSelectedDocuments(null);
    },
    checkDraftDocuments() {
      return this.getDraftDocuments && this.getDraftDocuments.length > 0;
    },
    beforeWindowUnload(e) {
      if (this.checkDraftDocuments()) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
    confirmSave() {
      this.$root.$emit("bv::show::modal", "modal-save_changes");
    },
    handleEstimationsPreviewUpdate(newPreview) {
      this.$emit("estimations-preview-updated", newPreview);
    }
  },
  beforeDestroy() {}
};
</script>
